import React, { Component } from 'react';

export interface IMessageModalProps {
    onClose: () => void;
    text: string;
    type: string;
}

interface IMessageModalState {
    text: string;
    type: string;
}

export default class MessageModal extends Component<
    IMessageModalProps,
    IMessageModalState
> {
    constructor(props: IMessageModalProps) {
        super(props);

        this.state = {
            text: props.text,
            type: props.type
        };
    }

    componentWillReceiveProps(nextProps: IMessageModalProps) {
        this.setState({
            text: nextProps.text,
            type: nextProps.type
        });
    }

    onClickStorno() {
        this.props.onClose();
    }

    render() {
        var text = this.state.text;

        return (
            <div className="modalOverlay">
                <div className="modalSlide">
                    <div className="modal">
                        <button
                            className="close"
                            onClick={() => this.onClickStorno()}
                        />
                        <div className="modal-header">
                            <h3>{this.state.type}</h3>
                        </div>
                        <div className="modal-content">
                            <p>{text}</p>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn--xsmallpill btn--borderRed btn--colorRed"
                                onClick={() => this.onClickStorno()}
                            >
                                Ok
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MessageModal.tsx